import i18n from 'i18next';
import { initReactI18next } from 'react-i18next';
import LanguageDetector from 'i18next-browser-languagedetector';
import { getDomainConfig } from '../config/domainConfig';

const { defaultLanguage } = getDomainConfig();

i18n
  .use(LanguageDetector) // Detects language from browser
  .use(initReactI18next)  // Passes i18n instance to react-i18next
  .init({
    resources: {
      nl: { translation: require('../resources/dutch/translation.json') },  // Dutch translations
      en: { translation: require('../resources/english/translation.json') },  // English translations
      hi: { translation: require('../resources/hindi/translation.json') }  // Hindi translations
    },
    lng: defaultLanguage.toLowerCase(),
    fallbackLng: defaultLanguage.toLowerCase(),
    interpolation: {
      escapeValue: false // React already does escaping
    }
  });

export default i18n;